import { Teams } from "./../data";
export default {
  mounted() {
    if (Teams.includes(this.$route.params.team)) {
      this.found = true;
    }
  },
};
